<template>
    <v-card id="mapconteiner" elevation="8" class="ma-5 mt-10" style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
        <v-container class="size" fluid>
            <v-layout row justify-start>
                 <v-flex lg12 md12 sm12 xs12 pa-1>
                    <v-layout row justify-start>
                        <v-flex xs12 md12 pl-2>
                            <h3><b>Estabelecimentos por Município</b></h3>
                        </v-flex>
                    </v-layout>
                    <v-form v-model="isFormValid" ref="form">
                        <v-layout row wrap justify-start class="pl-2">
                            <v-flex class="item" lg2 md2 sm6 xs12 pa-1>
                                <v-autocomplete v-on:keyup.enter="loadPropriedades" :rules="[campoSelectObrigatorio]" v-model="cdUf" :items="ufs"
                                    color="primary" item-text="sgUf" item-value="idUf" label="Selecione a UF"
                                    no-data-text="Nenhum registro" outlined clearable>
                                </v-autocomplete>
                            </v-flex>
                            <v-flex class="item" lg2 md2 sm6 xs12 pa-1>
                                <v-autocomplete v-on:keyup.enter="loadPropriedades" :rules="[campoSelectObrigatorio]" v-model="cdMunicipio" :items="filteredCities"
                                    color="primary" item-text="nmMunicipio" item-value="idMunicipio" label="Selecione o Município"
                                    no-data-text="Nenhum registro" outlined clearable>
                                </v-autocomplete>
                            </v-flex>
                            <v-flex class="item" lg2 md2 sm2 xs12 pa-3>
                                <v-btn id="search" dark rounded color="primary" @click="loadPropriedades">
                                    <span class="marginSpan"> Atualizar </span>
                                    <v-icon small>fa-sync-alt</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                    <v-layout row wrap justify-start pl-3 pb-1 style="margin-top:-5px;">
                        <v-flex class="item" lg12 md12 sm12 xs12>
                            <h5>Estabelecimentos sem Latitude e Longitude ou com coordenadas inválidos não serão exibidas no mapa!</h5>
                        </v-flex>
                    </v-layout>
                    <div style="height: 600px;" id="mapdiv"></div>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster"
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
import chroma from "chroma-js"
import axios from "axios"

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

import { campoSelectObrigatorio } from '@/filters/rules'

const offStyle = {
    color: "grey",
    weight: 1,
    fill: true,
    opacity: 1,
    fillOpacity: 0
};

const onStyle = {
    color: "grey",
    weight: 1,
    fill: true,
    opacity: 1,
    fillOpacity: 0.3
};

export default {
    data() {
        return {
            isFormValid: false,
            min: 0,
            max: 100,
            mapLayerControl: null,
            map: null,
            info: null,
            pontos: null,
            cities: null,
            cityCodes: [],
            objMarkers: [],
            cdUf: 0,
            cdMunicipio: 0,
            filteredCities: [],
            listMunicipios: []
        }
    },
    computed: {
        ufs () {
            return this.$store.state.ufs
        },
        estabelecimentos () {
            return this.$store.state.estabelecimentos
        },
        municipios () {
            return this.$store.state.municipios
        }
    },
    methods: {
        campoSelectObrigatorio,
        initViewFromRoute(route) {
            this.$store.dispatch('actLoadEstabelecimentos')
            this.$store.dispatch('actLoadUFs')
            this.cdUf = 42
            this.$store.dispatch('actLoadMunicipiosByUf', 42)
            this.initDados()
            this.initMap()
        },
        initDados() {
            var context = this
            context.listMunicipios = []
            context.estabelecimentos.forEach(function(estabelecimento){
                var municipio = context.municipios.find(m => m.idMunicipio == estabelecimento.cdMunicipio)
                if (municipio != undefined)
                {
                    if (context.listMunicipios.find(m => m.idMunicipio == municipio.idMunicipio) == undefined)
                    {
                        context.listMunicipios.push(municipio)
                    }
                }
            })
            context.filteredCities = context.listMunicipios.filter( mn => mn.cdUf == context.cdUf).sort().reverse()
        },
        initMap() {
            this.map = L.map("mapdiv", {
                center: [-27.019984, -51.064453],
                zoom: 7,
                worldCopyJump: true
            })
            this.mapLayerControl = L.control.layers({}, {}).addTo(this.map)
            this.pontos = L.featureGroup().addTo(this.map)

            var openStreetLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', 
                {
                    maxZoom: 12,
                    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' + 
                    '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
                })

            var streetBasicsLayer = L.tileLayer(
                "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw",
                {
                    maxZoom: 18,
                    attribution:
                        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
                        '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                        'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                    id: "mapbox.streets-basic"
                }
            ).addTo(this.map)

            this.info = L.control()

            this.info.onAdd = function(map){
                this._div = L.DomUtil.create('div', 'legenda')
                this.update()
                return this._div
            }

            this.info.update = function(element, nrTotal, nrSemDados) {
                this._div.innerHTML = (element ? 
                    '<b>' + element + '</b><br/> Exibidos: ' + nrTotal + '<br/> Com coordenadas inválidas: ' + nrSemDados : 
                    'Selecione o município')
            }

            this.info.addTo(this.map)

            this.cities = L.geoJSON().addTo(this.map)

            this.mapLayerControl.addBaseLayer(streetBasicsLayer, "Básico")
            this.mapLayerControl.addBaseLayer(openStreetLayer, "Detalhado")

            this.mapLayerControl.addOverlay(this.cities, "Divisões Geográficas")
            this.mapLayerControl.addOverlay(this.pontos, "Propriedades")
        },
        loadPropriedades() {
            var context = this;
            if (this.$refs.form.validate())
            {
                var propriedades = context.estabelecimentos.filter(e => e.cdMunicipio == this.cdMunicipio).sort()
                context.loadMash()
                context.loadMarkers(propriedades)
            }
        },
        loadMarkers(propriedades) {
            var context = this
            var nrTotal = 0
            var nrSemDados = 0
            context.pontos.clearLayers()
            context.objMarkers = []
            var myIcon = L.icon({
                iconUrl: icon,
                shadowUrl: iconShadow,
                iconSize: [24,36],
                iconAnchor: [12,36],
                popupAnchor: [0, -35],
            })

            propriedades.forEach(function(p) {
                if (p.nrLatitude != null && p.nrLongitude != null)
                {
                    nrTotal = nrTotal + 1
                    var group = context.objMarkers[p.nrLatitude]
                    if (group == undefined)
                    {
                        group = L.markerClusterGroup({
                            iconCreateFunction: function(cluster) {
                                var childCount = cluster.getChildCount()
                                var c = ' marker-cluster-'
                                if (childCount < 5) {
                                    c += 'small'
                                } 
                                else if (childCount < 10) {
                                    c += 'medium'
                                } 
                                else {
                                    c += 'large'
                                }

                                return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', 
                                    className: 'marker-cluster' + c, iconSize: new L.Point(40, 40) })
                            }
                        })

                        context.pontos.addLayer(group)

                        context.objMarkers[p.nrLatitude] = group
                    }

                    var text = p.nrCodigoOficial + ' - ' + p.nmEstabelecimento + '<br>(Lat: ' + p.nrLatitude + ' Long: ' + p.nrLongitude + ')'
                    group.addLayer(L.marker([p.nrLatitude, p.nrLongitude], {
                        radius: 2,
                        color: 'black',
                        fillColor: 'white',
                        stroke: false,
                        fillOpacity: 0.8,
                        icon: myIcon,
                    }).bindPopup(text).on('dblclick', L.bind(context.goToEstabelecimento, null, p.idEstabelecimento)))

                    context.pontos.addLayer(group)
                }
                else
                {
                    nrSemDados = nrSemDados + 1
                }
            })
            var nmMunicipio = context.filteredCities.find(x => x.idMunicipio == context.cdMunicipio).nmMunicipio
            context.info.update(nmMunicipio, nrTotal, nrSemDados)
            if (nrTotal > 0)
            {
                context.map.fitBounds(context.pontos.getBounds())
            }
        },
        goToEstabelecimento(idEstabelecimento) {
            this.$router.push({name: 'estabelecimento', params: {id: idEstabelecimento}})
        },
        loadMash(scale) {
            this.cities.clearLayers()
            axios.get(`https://servicodados.ibge.gov.br/api/v2/malhas/${this.cdMunicipio}?formato=application/vnd.geo+json`, {
                    params: {
                        resolucao: 5
                    }
                })
                .then(response => {
                    var layerData = L.geoJSON(response.data, {
                        style: () => {
                            return offStyle
                        },
                        pane: "tilePane",
                        onEachFeature: (feature, layer) => {
                            var style = {
                                fillColor: 'red',
                                weight: 1,
                                fill: true,
                                opacity: 1,
                                fillOpacity: 0.5
                            }

                            layer.setStyle(style)
                        }
                    })
                    this.cities.addLayer(layerData)
                })
                .catch(error => {
                    this.$store.commit("setSnack", { type: "error", msg: error })
                })
        },
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
        'cdUf' (value){
            this.filteredCities = []
            if (value != undefined)
            {
                if (!this.municipios.some(function(elem) { return elem.cdUf == value}) && value != 0)
                {
                    this.$store.dispatch('actLoadMunicipiosByUf', value)
                }
                else
                {
                    this.filteredCities = this.municipios.filter(x => x.cdUf == value)
                }
            }
            this.cdMunicipio = 0
        },
        'municipios' (value) {
            this.filteredCities = value.filter(x => x.cdUf == this.cdUf)
        }
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
}
</script>

<style>
#app {
  height: 100%;
  margin: 0;
}

#mapconteiner,
.size {
  height: 95%;
}
#mapdiv, #map {
    height: 93%;
    position: sticky !important;
}
.marginSpan {
    margin: 5px;
}
.legenda { 
    padding: 6px 8px; 
    font: 14px/16px Arial, Helvetica, sans-serif; 
    background: white; 
    background: rgba(255,255,255,0.8); 
    box-shadow: 0 0 15px rgba(0,0,0,0.2); 
    border-radius: 5px; 
} 
.legenda h4 { 
    margin: 0 0 5px;
    color: #777; 
}
</style>
